<template>
    <div>
        <Head class="head" />
        <div class="blank"></div>
        <div class="notice_bg">
            <div class="titleControll">
                <div class="title">
                    企业报名
                </div>
                <div @click="toAdmin" class="enter">进入企业管理页面</div>
            </div>
            <div class="line"></div>
            <div class="title_Word">企业基本信息</div>
            <div class="tableControll">
                <div class="total">
                    <div class="letter">企业名称:</div>
                    <div class="cont">{{ enter.name }}</div>
                </div>
                <div class="total">
                    <div class="letter">社会信用代码:</div>
                    <div class="cont">{{ enter.code }}</div>
                </div>
                <div class="total">
                    <div class="letter">联系人:</div>
                    <div class="cont">{{ enter.username }}</div>
                </div>
                <div class="total">
                    <div class="letter">联系人手机号:</div>
                    <div class="cont">{{ enter.mobile }}</div>
                </div>
                <div class="total">
                    <div class="letter">工作州市:</div>
                    <div class="cont">{{ addressId[enter.addressId] }}</div>
                </div>
            </div>
            <div class="addBtn">
                <el-button type="primary" @click="dialogVisible = true">添加学员</el-button>
                <el-button type="primary" @click="londHistorys()">加载历史学员</el-button>
            </div>
            <div class="tableDetail">
                <el-table :data="tableData" border style="width: 100%" align="center">
                    <el-table-column prop="name" label="序号" width="60" align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                        </template></el-table-column
                    >
                    <el-table-column prop="username" label="姓名" width="110" align="center"> </el-table-column>
                    <el-table-column prop="cardid" label="身份证号码" width="200" align="center"> </el-table-column>
                    <el-table-column prop="mobile" label="手机号" align="center"> </el-table-column>
                    <el-table-column prop="bookLevel" label="学员身份" align="center">
                        <template slot-scope="scope">
                            <span>{{ bookLevel[scope.row.bookLevel] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="do" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" class="checkCert" @click.native.prevent="deleteRow(scope.$index, tableData)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="applyBtn">
                <el-button type="primary" @click="justSave">
                    保存
                    <!-- <router-link to="/home/company/detail" class="router-link-active">立即报名 </router-link> -->
                </el-button>
                <el-button type="primary" @click="baoming" :loading="loading">
                    立即报名
                    <!-- <router-link to="/home/company/detail" class="router-link-active">立即报名 </router-link> -->
                </el-button>
                <!--                <el-button type="primary">-->
                <!--                    <router-link to="/home/company/detail" class="router-link-active">一键导出</router-link>-->
                <!--                </el-button>-->
            </div>
            <!--已报名学员（已缴费且成功展示，首次进来无该列表）-->
            <!--            <div class="title" style="margin-top:40px;">已报名学员</div>-->
            <!--            <div class="line" style="width:100%;"></div>-->
            <!--            <div class="tableDetail">-->
            <!--                <el-table :data="successInfo" border style="width: 100%" align="center">-->
            <!--                    <el-table-column prop="name1" label="序号" width="60" align="center"> </el-table-column>-->
            <!--                    <el-table-column prop="name1" label="姓名" width="110" align="center"> </el-table-column>-->
            <!--                    <el-table-column prop="name2" label="身份证号码" width="180" align="center"> </el-table-column>-->
            <!--                    <el-table-column prop="name3" label="手机号" align="center"> </el-table-column>-->
            <!--                    <el-table-column prop="name4" label="所属地州" align="center"> </el-table-column>-->
            <!--                    <el-table-column prop="name5" label="学员身份" align="center"> </el-table-column>-->
            <!--                </el-table>-->
            <!--            </div>-->
            <!--            <div class="addBtn">-->
            <!--                <el-button type="primary">批量导出</el-button>-->
            <!--                <el-button type="primary">开具发票</el-button>-->
            <!--            </div>-->
        </div>
        <div class="blank_f"></div>
        <Foot class="foot" />
        <!--添加学员弹窗-->
        <el-dialog class="addDialog" :visible.sync="dialogVisible" width="40%">
            <div class="title">添加学员</div>
            <div class="line"></div>
            <el-form class="addControll" ref="addform" :model="addform" :rules="rules" label-width="130px">
                <el-form-item label="姓名" style="width: 430px" prop="username">
                    <el-input v-model="addform.username" placeholder="请输入学员姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" style="width: 430px" prop="cardid">
                    <el-input v-model="addform.cardid" placeholder="请输入身份证号码"></el-input>
                </el-form-item>
                <el-form-item label="手机号" style="width: 430px" prop="mobile">
                    <el-input v-model="addform.mobile" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="选择学员的身份" style="width: 430px" prop="bookLevel">
                    <el-select v-model="addform.bookLevel" placeholder="选择学员的身份">
                        <el-option v-for="(item, index) in bookLevel" :key="index" :label="item" :value="index"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit">添加</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>

        <!--缴费成功对话框-->
        <el-dialog title="提示" :visible.sync="showPayModel">
            <span>支付是否成功？</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="rePay">重新支付</el-button>
                <el-button type="primary" @click="successAdd">支付成功，继续添加学员</el-button>
                <el-button type="primary" @click="toAdmin">支付成功，去开发票</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Foot from '@/components/Foot';
import Head from '@/components/Head';
import bm from '@/api/bm';
import enter from '@/api/enter';
export default {
    components: { Head, Foot },
    data() {
        return {
            showPayModel: false, // 支付成功的弹出宽
            toOrderPayUrl: '', // 需要跳转到的支付地址
            loading: false, // 是否在加载中
            tableData: [],
            form: {
                company_name: '',
                company_code: '',
                link_people: '',
                link_mobile: '',
                region: ''
            },
            addform: {
                username: '',
                cardid: '',
                mobile: '',
                addressId: '',
                bookLevel: '',
                enterpriseId: ''
            },
            dialogVisible: false,
            rules: {
                company_name: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
                company_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
                link_peoples: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
                region: [{ required: true, message: '请选择工作州市', trigger: 'blur' }],
                link_mobile: [{ required: true, message: '请输入联系人手机号', trigger: 'blur' }],
                //添加学员
                username: [{ required: true, message: '请输入学员姓名', trigger: 'blur' }],
                cardid: [{ required: true, message: '请输入身份证号码', trigger: 'blur' }],
                bookLevel: [{ required: true, message: '请选择学员身份', trigger: 'blur' }],
                mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
            },
            enter: {},
            addressId: [],
            bookLevel: [],
            signUpInfo: {}
        };
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.$refs.addform.resetFields();
            }
        }
    },
    created() {
        this.$store.dispatch('get_enter');
        this.enter = this.$store.getters.enter;
        this.getBaseinfo();
        this.signUpArrangement();
    },
    methods: {
        // 从缓存中载入学员
        londHistorys() {
            let reData = localStorage.getItem('userTableList');
            if (reData) {
                reData = JSON.parse(reData);

                for (let index = 0; index < reData.length; index++) {
                    const element2 = reData[index];

                    // 尝试把缓存数据加入
                    this.addform = {
                        username: element2.username,
                        cardid: element2.cardid,
                        mobile: element2.mobile,
                        addressId: element2.addressId,
                        bookLevel: element2.bookLevel,
                        enterpriseId: element2.enterpriseId
                    };

                    // 验证当前身份证号码是否存在于现在的列表中
                    for (let index = 0; index < this.tableData.length; index++) {
                        const element = this.tableData[index];
                        if (element.cardid === this.addform.cardid) {
                            // this.$message.error('此用户已再列表中添加过');
                            return false;
                        }
                    }

                    let from = JSON.parse(JSON.stringify(this.addform));
                    from.addressId = this.enter.addressId;
                    from.enterpriseId = this.enter.id;
                    from.token = this.enter.token;

                    enter
                        .enterRegister(from)
                        .then(res => {
                            this.tableData.unshift(from);
                            this.addform = {
                                username: '',
                                cardid: '',
                                mobile: '',
                                addressId: '',
                                bookLevel: '',
                                enterpriseId: ''
                            };
                        })
                        .catch(err => {
                            console.error(err);
                        });
                }
            }
        },
        toAdmin() {
            let enterUser = this.$store.getters.enter;
            if (enterUser.code) {
                enter
                    .toAdmin(enterUser.code)
                    .then(res => {
                        if (res.data) {
                            window.open(res.data, '_blank');
                        }
                    })
                    .catch(err => {
                        if (err.code == 0) {
                            this.$message.error(err.msg);
                        } else if (typeof err == 'string') {
                            this.$message.error(err);
                        } else {
                            this.$message.error('发生异常情况， 请联系管理人员');
                            console.log(err);
                        }
                    });
            }
        },

        // 获取报名信息
        signUpArrangement() {
            enter
                .signUpArrangement()
                .then(res => {
                    res.data = {
                        id: '1',
                        signUpYear: 2021,
                        trainTypeId: '1385043565777768449',
                        trainTypeName: '宣贯培训',
                        notice:
                            '<p>欢迎参加《云南省建设工程造价计价标准（2020版）》宣贯培训。</p><p><br></p><p>1、请各位学员务必在在6月1号前完成培训，我们将在在6月2号~6月7号进行集中答疑；各位学员报名成功后可在学习系统里扫码加入答疑微信群进去问题反馈。</p><p><br></p><p>2、个人报名流程：</p><p>点击个人报名 -&gt; 输入所需的报名信息 ，并核对信息 -&gt; 提交报名信息并会生成订单信息 -&gt; 根据系统提示完成缴费 -&gt; 个人报名成功。</p><p><br></p><p>3、企业批量报名：</p><p>输入单位名称、企业统一社会信用代码、添加学员信息 → 确认提交报名 → 根据系统提示完成缴费 → 单位批量报名成功。</p><p><br></p><p>4、缴费说明</p><p>个人报名或企业批量报名时未同步完成缴费的，后续亦可登录学习系统进行缴费。个人报名的使用报名的身份证号登录，默认密码为身份证号后八位；企业报名的使用社会信用码登录，默认密码为社会信用码后八位。</p><p><br></p><p>5、上传缴费凭证说明：如企业批量报名后选择线下转账支付继续教育培训费用，转账成功后需及时登录本平台上传缴费凭证，我司确认款项到账方后方能开通课程学习权限。</p><p><br></p><p>6、账号及开具发票说明</p><p>报名成功缴费后，用学员身份证号码及登录密码（默认密码为身份号后八位）登录学习系统；亦可使用企业账号登录学习系统进行订单管理及开具发票，企业账号为企业统一社会信用代码，默认密码为企业统一社会信用代码后八位。本次培训开具增值税电子普通发票，开票内容为：云南省建设工程造价计价标准（2020版）-宣贯培训费用，在申请开票后5个工作日内开具。</p><p><br></p><p>7、培训合格证书：登录学习系统，进入“我的课程”，所有必须课程学习完成后即可查看培训完成证书。</p><p><br></p><p>8、报名咨询、缴费、发票、培训平台学习相关问题咨询电话：沈老师、李老师（0871-63122229）</p>',
                        startTime: '2021-04-23 13:52:56',
                        price: 0.01,
                        compulsoryCourseId:
                            '1385044496011481090,1385045737529659393,1385434201769005057,1385434325266092033,1385434726870700034,1385435037395996673,1385435138344505345,1385435255155871745',
                        compulsoryCourseNames:
                            '计价规则,建筑工程,市政工程,通用安装工程,园林绿化工程,绿色建筑工程,装配式建筑工程,综合管廊工程',
                        lowerLimit: 0,
                        certificateRuleSetting: 1,
                        studyFinishSetting: 0,
                        certificateTitle: '《云南省建设工程造价计价标准（2020版）》宣贯培训\n',
                        endTime: '2021-05-30 13:52:56',
                        sectionTotal: 32
                    };

                    this.signUpInfo = {
                        signUpYear: res.data.signUpYear,
                        trainTypeId: res.data.trainTypeId,
                        courses: res.data.compulsoryCourseId
                    };
                })
                .catch(err => {
                    console.log(err);
                });
        },
        // 重新支付
        rePay() {
            window.open(this.toOrderPayUrl, '_blank');
        },
        // 支付成功，继续添加学员
        successAdd() {
            this.tableData = [];
            this.toOrderPayUrl = null;
            this.showPayModel = false;
        },
        // 保存到缓存中
        justSave() {
            localStorage.setItem('userTableList', JSON.stringify(this.tableData));
            this.$message.success('本地存储成功');
        },
        // 报名
        async baoming() {
            let from = JSON.parse(JSON.stringify(this.signUpInfo));
            from.token = this.$store.getters.token;

            from.idCardNumber = [];

            // 此处缓存用户信息
            // console.log(this.tableData);
            localStorage.setItem('userTableList', JSON.stringify(this.tableData));

            this.tableData.forEach(item => {
                from.idCardNumber.push(item.cardid.trim());
            });
            from.idCardNumber = from.idCardNumber.join(',');

            this.loading = true;
            try {
                const res = await enter.QYSignUp(from);
                this.toOrderPayUrl = res.data.toOrderPayUrl;
                window.open(this.toOrderPayUrl, '_blank');
                // 打开支付对话框
                this.showPayModel = true;
            } catch (err) {
                if (err.code == 0) {
                    this.$message.error(err.msg);
                } else if (typeof err == 'string') {
                    this.$message.error(err);
                } else {
                    this.$message.error('发生异常情况， 请联系管理人员');
                    console.log(err);
                }
            }
            this.loading = false;
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
        },
        getBaseinfo() {
            bm.baseinfo()
                .then(res => {
                    this.bookLevel = res.data.bookLevel;
                    this.addressId = res.data.addressId;
                })
                .catch(err => {
                    if (err.code == 0) {
                        this.$message.error(err.msg);
                    } else if (typeof err == 'string') {
                        this.$message.error(err);
                    } else {
                        this.$message.error('发生异常情况， 请联系管理人员');
                        console.log(err);
                    }
                });
        },
        submit() {
            this.$refs.addform.validate(valid => {
                if (!valid) {
                    return false;
                }

                // 验证当前身份证号码是否存在于现在的列表中
                for (let index = 0; index < this.tableData.length; index++) {
                    const element = this.tableData[index];
                    if (element.cardid === this.addform.cardid) {
                        this.$message.error('此用户已再列表中添加过');
                        return false;
                    }
                }

                let from = JSON.parse(JSON.stringify(this.addform));
                from.addressId = this.enter.addressId;
                from.enterpriseId = this.enter.id;
                from.token = this.enter.token;

                enter
                    .enterRegister(from)
                    .then(res => {
                        this.tableData.unshift(from);
                        this.dialogVisible = false;
                    })
                    .catch(err => {
                        if ([0, 2].includes(err.code * 1)) {
                            this.$message.error(err.msg);
                        } else if (typeof err == 'string') {
                            this.$message.error(err);
                        } else {
                            this.$message.error('发生异常情况， 请联系管理人员');
                            console.log(err);
                        }
                    });
            });
        }
    }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
    min-width: 500px;
}
.notice_bg {
    width: 1110px;
    background: #fff;
    margin-bottom: 50px;
    border-radius: 4px;
    margin: auto;
    margin-top: 50px;
    color: #606266;
    padding: 30px 50px;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 25px;
    min-height: calc(100vh - 230px);
    .titleControll {
        justify-content: space-between;
        display: flex;
        .title {
            font-weight: bold;
            font-size: 18px;
            color: #333;
            letter-spacing: 5px;
            display: flex;
        }
        .enter {
            font-size: 14px;
            cursor: pointer;
            transition: all 0.3s;
            &:hover {
                color: rgb(70, 124, 248);
            }
        }
    }
    .line {
        border: 1px solid #f5f5f5;
        margin-top: 30px;
        width: 70%;
    }
    .title_Word {
        margin-top: 40px;
        font-size: 16px;
        color: #333;
        letter-spacing: 2px;
    }
    .tableControll {
        margin-top: 30px;
        width: 42%;
        .total {
            display: flex;
            align-items: center;
            height: 40px;
            font-size: 16px;
            margin-left: 30px;
            .cont {
                margin-left: 20px;
            }
            .letter {
                width: 100px;
                text-align: justify;
                text-align-last: justify;
            }
        }
    }
    .tableDetail {
        margin-top: 30px;
    }
    .applyBtn {
        margin-top: 30px;
        /deep/ .el-button--small,
        .el-button--small.is-round {
            padding: 9px 30px;
        }
        /deep/ .el-select {
            width: 100%;
        }
    }
}
.foot {
    width: 100%;
}
.head {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 99;
    width: 100%;
}
.blank {
    height: 80px;
    width: 100%;
}
.blank_f {
    height: 20px;
    width: 100%;
}
/deep/ .el-select {
    width: 100%;
}
.addDialog {
    .title {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        letter-spacing: 5px;
    }
    .line {
        border: 1px solid #f5f5f5;
        margin-top: 30px;
        width: 80%;
    }
    .addControll {
        margin-top: 30px;
        /deep/ .el-dialog__body {
            padding: 30px 50px;
        }
    }
    /deep/ .el-dialog__footer {
        padding: 10px 20px 20px;
        text-align: right;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
    }
    /deep/ .el-button--small,
    .el-button--small.is-round {
        padding: 9px 35px;
    }
}
a {
    text-decoraction: none !important;
}
.router-link-active {
    text-decoration: none !important;
    color: #fff;
    transition: all 0.3s;
    &:hover {
        color: #fff;
    }
}
.addBtn {
    display: flex;
    justify-content: flex-start;
    margin-top: 40px;
    /deep/ .el-button--small,
    .el-button--small.is-round {
        padding: 9px 30px;
    }
}
</style>
